import { gql } from "@apollo/client";

export const GENERATE_SUBSCRIPTION_AGREEMENT_PDF = gql`
  mutation generateSubscriptionAgreementPdf($id: String!) {
    generateSubscriptionAgreementPdf(id: $id){
      success
      message
    }
  }
`;